const GET_URL_LANGUAGE = 'language/GET_URL_LANGUAGE';
const GET_URL_LANGUAGE_SUCCESS = 'language/GET_URL_LANGUAGE_SUCCESS';

export default {
    GET_URL_LANGUAGE,
    GET_URL_LANGUAGE_SUCCESS
};
